import React, { memo, useMemo } from 'react'
import { Form, Formik, FormikHelpers } from 'formik'
import type { RemoteConfigApp } from 'src/constants/remote-config/remoteConfig'
import type {
  RemoteConfig,
  RemoteConfigFormMode,
  RemoteConfigFormValues,
} from 'src/interfaces/remoteConfig'
import { buildRemoteConfigFormValues } from 'src/utils/remoteConfig/remoteConfigValue'
import { RemoteConfigFormContent } from './RemoteConfigFormContent'
import { buildRemoteConfigFormValidator } from './RemoteConfigForm.validator'

interface Props {
  formId: string
  mode: RemoteConfigFormMode
  remoteConfig: RemoteConfig | null
  defaultApp: RemoteConfigApp
  existingRemoteConfigs: RemoteConfig[]
  onSubmit(values: RemoteConfigFormValues, helpers: FormikHelpers<RemoteConfigFormValues>): void
}

const RemoteConfigFormComponent = ({
  formId,
  mode,
  remoteConfig,
  defaultApp,
  existingRemoteConfigs,
  onSubmit,
}: Props) => {
  const initialValues = useMemo(() => {
    return buildRemoteConfigFormValues(remoteConfig, defaultApp)
  }, [remoteConfig, defaultApp])

  const validationSchema = useMemo(() => {
    return buildRemoteConfigFormValidator({ mode, existingRemoteConfigs })
  }, [mode, existingRemoteConfigs])

  return (
    <Formik<RemoteConfigFormValues>
      initialValues={initialValues}
      validationSchema={validationSchema}
      enableReinitialize
      onSubmit={onSubmit}
    >
      <Form id={formId} noValidate>
        <RemoteConfigFormContent mode={mode} />
      </Form>
    </Formik>
  )
}

export const RemoteConfigForm = memo(RemoteConfigFormComponent)
